import { MenuItem } from "@material-ui/core";
import { SysadminData } from "../SysadminData";

/** Office menu items labelled with their company, sorted by company and office name. */
export function officeOptions(data: SysadminData) {
    return data.offices
        .map(({ content }) => ({ id: content.id, office: content.officeName, company: data.companyById(content.companyId)?.companyName ?? "Unknown company" }))
        .sort((a, b) => a.company.localeCompare(b.company) || a.office.localeCompare(b.office))
        .map(o => <MenuItem key={o.id} value={o.id}>{o.office} <span style={{ opacity: 0.6, marginLeft: 8 }}>({o.company})</span></MenuItem>);
}

/** Eater group menu items for one office, sorted by name. */
export function eaterGroupOptions(data: SysadminData, officeId: string) {
    return data.eaterGroups
        .filter(({ content }) => content.officeId === officeId)
        .sort((a, b) => a.content.eaterGroupName.localeCompare(b.content.eaterGroupName))
        .map(({ content }) => <MenuItem key={content.id} value={content.id}>{content.eaterGroupName}</MenuItem>);
}
